var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grabpage" },
    [
      _c("div", { staticClass: "container-top" }, [
        _c("div", { staticClass: "search" }, [
          _c(
            "div",
            [
              _c("span", [_vm._v("询单号:")]),
              _c("el-input", {
                attrs: { size: "mini", placeholder: "请输入询单号" },
                model: {
                  value: _vm.inquiryNumber,
                  callback: function ($$v) {
                    _vm.inquiryNumber = $$v
                  },
                  expression: "inquiryNumber",
                },
              }),
              _c("button", [_vm._v("查询")]),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "redio-list" },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.radioType,
                  callback: function ($$v) {
                    _vm.radioType = $$v
                  },
                  expression: "radioType",
                },
              },
              [
                _c("el-radio", { attrs: { label: "0" } }, [_vm._v("全部")]),
                _c("el-radio", { attrs: { label: "1" } }, [_vm._v("可抢的")]),
                _c("el-radio", { attrs: { label: "2" } }, [
                  _vm._v("已抢等待结果"),
                ]),
                _c("el-radio", { attrs: { label: "3" } }, [_vm._v("我抢到的")]),
                _c("el-radio", { attrs: { label: "4" } }, [_vm._v("被抢走的")]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "container-bottom" },
        [
          _c(
            "el-table",
            {
              ref: "tableData",
              staticStyle: { width: "100%" },
              attrs: {
                "header-cell-style": { color: "#000000" },
                data: _vm.tableData,
              },
            },
            [
              _c(
                "el-table-column",
                { attrs: { width: "50" } },
                [[_c("i", { staticClass: "el-icon-arrow-right" })]],
                2
              ),
              _c("el-table-column", {
                attrs: { align: "center", label: "询单号", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type == 1
                          ? _c("p", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "20px",
                                    "background-color": "#f3afb9",
                                    width: "61px",
                                    "text-align": "center",
                                    "line-height": "19px",
                                    "border-radius": "5px",
                                    color: "#fff",
                                  },
                                },
                                [_vm._v("私家团")]
                              ),
                              _c("br"),
                            ])
                          : _c("p", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "20px",
                                    border: "1px solid #f3afb9",
                                    width: "61px",
                                    "text-align": "center",
                                    "line-height": "19px",
                                    "border-radius": "5px",
                                    color: "rgb(243, 175, 185)",
                                  },
                                },
                                [_vm._v("企业团")]
                              ),
                              _c("br"),
                            ]),
                        _c("span", [_vm._v(_vm._s(scope.row.id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  height: "40",
                  align: "center",
                  label: "询单人",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                width: "33px",
                                transform: "translateY(6px)",
                                "text-align": "center",
                                "line-height": "33px",
                                display: "block",
                                float: "left",
                                height: "33px",
                                "border-radius": "20px",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "border-radius": "20px",
                                  width: "100%",
                                  height: "100%",
                                },
                                attrs: {
                                  src: scope.row.createUserImage,
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                              },
                            },
                            [
                              scope.row.createName
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: scope.row.createName,
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            height: "23px",
                                            color: "#e96237",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.createName))]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        height: "23px",
                                        color: "#e96237",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.createName))]
                                  ),
                              scope.row.createCompanyName
                                ? _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: scope.row.createCompanyName,
                                        placement: "bottom",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            height: "23px",
                                            overflow: "hidden",
                                            "white-space": "nowrap",
                                            "text-overflow": "ellipsis",
                                            color: "#e96237",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.createCompanyName)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        height: "23px",
                                        overflow: "hidden",
                                        "white-space": "nowrap",
                                        "text-overflow": "ellipsis",
                                        color: "#e96237",
                                        "font-weight": "bold",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.createCompanyName)
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]),
                        scope.row.telephone != "" && scope.row.status == 1
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  background:
                                    "url(../../../static/resource/images/phonebackground.jpg)",
                                  "background-size": "100%",
                                  width: "131px",
                                  height: "30px",
                                  display: "block",
                                  "font-weight": "bold",
                                  "line-height": "30px",
                                },
                              },
                              [
                                _vm._v(
                                  "     " + _vm._s(scope.row.telephone) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "150", align: "center", label: "下单时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.dateFormatYMDHM(scope.row.createTime, "-")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "departurePlace",
                  label: "出发地",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "destination",
                  label: "目的地",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "150",
                  prop: "estimatedTravelStart",
                  label: "预估出行时间",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.inquiryMaintainList[0]
                          ? [
                              scope.row.inquiryMaintainList[0]
                                .estimatedTravelStart
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateFormatYMD(
                                          scope.row.inquiryMaintainList[0]
                                            .estimatedTravelStart,
                                          "-"
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0]
                                .estimatedTravelEnd
                                ? _c("br")
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0]
                                .estimatedTravelEnd
                                ? _c("span", [_vm._v("~")])
                                : _vm._e(),
                              _c("br"),
                              scope.row.inquiryMaintainList[0]
                                .estimatedTravelEnd
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateFormatYMD(
                                          scope.row.inquiryMaintainList[0]
                                            .estimatedTravelEnd,
                                          "-"
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.planNumber &&
                              scope.row.planNumber !== ""
                                ? _c("a", { staticClass: "see-plan" }, [
                                    _vm._v("查看行程"),
                                  ])
                                : _vm._e(),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "预估出行人数" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.type == 1
                          ? _c("p", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "20px",
                                    "background-color": "#eb7549",
                                    width: "61px",
                                    "text-align": "center",
                                    "line-height": "19px",
                                    "border-radius": "5px",
                                    color: "#fff",
                                  },
                                },
                                [_vm._v(" 私家团")]
                              ),
                              _c("br"),
                              scope.row.inquiryMaintainList[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.inquiryMaintainList[0]
                                          .estimatedTravelAdultNum
                                      ) + "成人"
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.inquiryMaintainList[0]
                                          .estimatedTravelAdultChildren
                                      ) + "儿童"
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        scope.row.type == 2
                          ? _c("p", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "20px",
                                    border: "1px solid #eb7549",
                                    width: "61px",
                                    "text-align": "center",
                                    "line-height": "19px",
                                    "border-radius": "5px",
                                    color: "rgb(243, 175, 185)",
                                  },
                                },
                                [_vm._v("企业团")]
                              ),
                              _c("br"),
                              scope.row.inquiryMaintainList[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.inquiryMaintainList[0]
                                          .estimatedTravelAdultNum
                                      ) + "成人"
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0]
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.inquiryMaintainList[0]
                                          .estimatedTravelAdultChildren
                                      ) + "儿童"
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "price",
                  label: "预估人均预算",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row.inquiryMaintainList[0]
                          ? [
                              _c("span", [
                                _vm._v(
                                  _vm._s(scope.row.inquiryMaintainList[0].price)
                                ),
                              ]),
                              _c("br"),
                              scope.row.inquiryMaintainList[0].type == 0
                                ? _c("span", [_vm._v("不含机票")])
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0].type == 1
                                ? _c("span", [_vm._v("含经济舱")])
                                : _vm._e(),
                              scope.row.inquiryMaintainList[0].type == 2
                                ? _c("span", [_vm._v("含公务/头等舱")])
                                : _vm._e(),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c("el-table-column", {
                attrs: { width: "150", label: "预估所需代订项目" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { content: scope.row.needService } },
                          [_c("span", [_vm._v(_vm._s(scope.row.needService))])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "planExpect", label: "期待及主题" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { content: scope.row.planExpect } },
                          [_c("span", [_vm._v(_vm._s(scope.row.planExpect))])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "customerMessage", label: "别的要求" },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "150",
                  label: "操作",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { "font-weight": "bold" } }),
                        _c("br"),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                              "align-items": "center",
                            },
                          },
                          [
                            scope.row.status == 0
                              ? _c(
                                  "el-popover",
                                  {
                                    ref: `popover-${scope.row.id}`,
                                    attrs: {
                                      "popper-class": "popper-self",
                                      "visible-arrow": "",
                                      offset: "-70",
                                      placement: "left",
                                      width: "350",
                                      trigger: "manual",
                                    },
                                    model: {
                                      value: scope.row.clonepopovershow,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "clonepopovershow",
                                          $$v
                                        )
                                      },
                                      expression: "scope.row.clonepopovershow",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-circle-close",
                                      staticStyle: {
                                        "font-size": "25px",
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        color: "#000",
                                      },
                                      on: {
                                        click: function ($event) {
                                          scope.row.clonepopovershow = false
                                        },
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "15px",
                                          cursor: "pointer",
                                          color: "#fff",
                                          "line-height": "38px",
                                          background: "#e65019",
                                          width: "103px",
                                          height: "38px",
                                          "text-align": "center",
                                          display: "block",
                                          margin: "50px auto",
                                          "font-weight": "bold",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.Confirmorder(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(" 确认抢单 ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "line-height": "25px",
                                          display: "inline-block",
                                          padding: "0px 0px 0px 28px",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("抢单后请关注，状态变化。")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                              "margin-bottom": "15px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " 如变成“我抢到啦！”则恭喜您已抢单成功！ "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(" 请点击"),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  margin: "5px 10px",
                                                  transform: "translateX(25px)",
                                                  padding: "6px 18px",
                                                  background:
                                                    "rgb(255, 114, 114)",
                                                  "line-height": "30px",
                                                  color: "rgb(255, 255, 255)",
                                                  "border-radius": "5px",
                                                  "box-shadow":
                                                    "rgb(0 0 0 / 40%) 0px 2px 6px 0px",
                                                },
                                              },
                                              [_vm._v("抢到啦！")]
                                            ),
                                            _vm._v("查看客人联系方式 "),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " 并在规定时间内和客人首呼，补充团队信息， "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              transform: "translateY(-10px)",
                                              "text-align": "left",
                                              "margin-bottom": "30px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " 并在我抢到了的单内查看及制作方案 "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          display: "block",
                                          "font-size": "20px",
                                          background: "#e64a19",
                                          height: "37px",
                                          width: "37px",
                                          "text-align": "center",
                                          "line-height": "37px",
                                          color: "#fff",
                                          "border-radius": "20px",
                                          "box-shadow":
                                            "0px 2px 6px 0px rgb(0 0 0 / 40%)",
                                        },
                                        attrs: { slot: "reference" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showConfirm(scope.row)
                                          },
                                        },
                                        slot: "reference",
                                      },
                                      [_vm._v("抢")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            scope.row.status == 2
                              ? _c("span", [_vm._v("哎呀~手慢了~被抢走了")])
                              : _vm._e(),
                            scope.row.status == 5
                              ? _c("span", [_vm._v("已转询")])
                              : _vm._e(),
                          ],
                          1
                        ),
                        scope.row.status == 1 || scope.row.status == 4
                          ? _c(
                              "p",
                              {
                                staticStyle: {
                                  margin: "5px 0",
                                  transform: "translateX(25px)",
                                  display: "block",
                                  width: "80px",
                                  height: "30px",
                                  background: "#ff7272",
                                  "text-align": "center",
                                  "line-height": "30px",
                                  color: "#fff",
                                  "border-radius": "5px",
                                  cursor: "pointer",
                                  "box-shadow":
                                    "0px 2px 6px 0px rgb(0 0 0 / 40%)",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.grabbedit(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 点击联系客户 ")]
                            )
                          : _vm._e(),
                        scope.row.status == 4
                          ? _c(
                              "p",
                              {
                                staticStyle: {
                                  margin: "5px 0",
                                  transform: "translateX(25px)",
                                  display: "block",
                                  width: "40px",
                                  height: "30px",
                                  background: "#ff7272",
                                  "text-align": "center",
                                  "line-height": "30px",
                                  color: "#fff",
                                  "border-radius": "5px",
                                  cursor: "pointer",
                                  "box-shadow":
                                    "0px 2px 6px 0px rgb(0 0 0 / 40%)",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.transferInquiry(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 转询 ")]
                            )
                          : _vm._e(),
                        scope.row.condition == 1
                          ? _c("span", [
                              _vm._v("客户好残忍"),
                              _c("br"),
                              _vm._v("取消询单了呢~"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.grabbeditdata.grabbeditshow == true,
              expression: "grabbeditdata.grabbeditshow == true",
            },
          ],
          staticClass: "ordershowcard",
        },
        [
          _c("i", {
            staticClass: "el-icon-circle-close",
            staticStyle: {
              "font-size": "25px",
              position: "absolute",
              top: "5px",
              right: "5px",
              color: "#000",
            },
            on: { click: _vm.clonsegrabbedit },
          }),
          _c("div", { staticClass: "ordershowcard-content" }, [
            _c("span", [_vm._v("恭喜您! 订单抢到了哦~~ ")]),
            _c("span", { staticStyle: { "margin-left": "2px" } }, [
              _vm._v("请尽快和客户联系。"),
            ]),
            _c(
              "p",
              {
                staticStyle: {
                  margin: "10px 0",
                  color: "rgb(230, 80, 25)",
                  "font-size": "16px",
                  "font-weight": "bold",
                },
              },
              [
                _vm._v(
                  " 客户电话：" + _vm._s(_vm.grabbeditdata.telephone) + " "
                ),
              ]
            ),
            _c("p", { staticStyle: { "margin-bottom": "17px" } }, [
              _vm._v(" 客户希望最多"),
              _c(
                "span",
                { staticStyle: { "font-size": "16px", "font-weight": "bold" } },
                [_vm._v(_vm._s(_vm.grabbeditdata.customizerNumber))]
              ),
              _vm._v(
                " 位定制师为其服务，您联系客户的速度、制作方案的速度、质量、以及价格,会很大程度上影响客户的最终选择~~ "
              ),
            ]),
            _c("div", { staticStyle: { background: "#f7f7f7" } }, [
              _c("div", [
                _c(
                  "p",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "margin-top": "28px",
                      "padding-bottom": "10px",
                      "border-bottom": "1px solid #ccc",
                    },
                  },
                  [
                    _vm.grabbeditdata.type == 1
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              height: "20px",
                              "background-color": "#eb7549",
                              width: "61px",
                              margin: "0 10px",
                              "margin-right": "15px",
                              "text-align": "center",
                              "line-height": "20px",
                              "border-radius": "5px",
                              color: "#fff",
                            },
                          },
                          [_vm._v("私家团")]
                        )
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              display: "inline-block",
                              height: "20px",
                              border: "1px solid #f3afb9",
                              width: "61px",
                              "text-align": "center",
                              margin: "0 10px",
                              "line-height": "20px",
                              "border-radius": "5px",
                              color: "rgb(243, 175, 185)",
                            },
                          },
                          [_vm._v(" 企业团")]
                        ),
                    _c("span", [_vm._v("客户沟通后信息更新：")]),
                  ]
                ),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("客户Email：")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0].email !=
                              "" && _vm.grabbeditdata.customerdatashow == false,
                          expression:
                            " grabbeditdata.inquiryMaintainList[0].email != ''&&grabbeditdata.customerdatashow == false",
                        },
                      ],
                      staticStyle: { "font-weight": "bold" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.grabbeditdata.inquiryMaintainList[0].email)
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.customerdatashow == true,
                          expression: "grabbeditdata.customerdatashow == true",
                        },
                      ],
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          placeholder: "请输入客户的电子邮箱",
                          size: "mini",
                        },
                        model: {
                          value: _vm.grabbeditdata.inquiryMaintainList[0].email,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "email",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].email",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentcustomerdata()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("备用电话：")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .standbyTelephone != "" &&
                            _vm.grabbeditdata.customerdatashow == false,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].standbyTelephone != '' &&grabbeditdata.customerdatashow == false",
                        },
                      ],
                      staticStyle: { "font-weight": "bold" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.grabbeditdata.inquiryMaintainList[0]
                            .standbyTelephone
                        )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.customerdatashow == true,
                          expression: " grabbeditdata.customerdatashow == true",
                        },
                      ],
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          placeholder: "请输入客户的电话号码",
                          size: "mini",
                        },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .standbyTelephone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "standbyTelephone",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].standbyTelephone",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("联系时间：")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .contactTime != "" &&
                            _vm.grabbeditdata.customerdatashow == false,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].contactTime != '' &&grabbeditdata.customerdatashow == false",
                        },
                      ],
                      staticStyle: { "font-weight": "bold" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.grabbeditdata.inquiryMaintainList[0].contactTime
                        )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.customerdatashow == true,
                          expression: "grabbeditdata.customerdatashow == true",
                        },
                      ],
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          placeholder: "请输入你的联系时间",
                          size: "mini",
                        },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .contactTime,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "contactTime",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].contactTime",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("出发地: ")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.destinationshow == false,
                          expression: "grabbeditdata.destinationshow == false",
                        },
                      ],
                    },
                    [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.grabbeditdata.departurePlace)),
                      ]),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.destinationshow == true,
                          expression: "grabbeditdata.destinationshow == true",
                        },
                      ],
                    },
                    [
                      _c("city-autocomplete", {
                        attrs: {
                          obj: _vm.grabbeditdata.inquiryMaintainList[0]
                            .departurePlaceObj,
                          sizeType: "small",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentdestination()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("目的地: ")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.destinationshow == false,
                          expression: "grabbeditdata.destinationshow == false",
                        },
                      ],
                    },
                    _vm._l(
                      _vm.grabbeditdata.inquiryMaintainList[0].destinationObj,
                      function (item, index) {
                        return _c("span", { key: index }, [
                          _vm._v(" " + _vm._s(item.cityName) + " "),
                        ])
                      }
                    ),
                    0
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.destinationshow == true,
                          expression: "grabbeditdata.destinationshow == true",
                        },
                      ],
                    },
                    [
                      _c(
                        "span",
                        _vm._l(
                          _vm.grabbeditdata.inquiryMaintainList[0]
                            .destinationObj,
                          function (tag, ind) {
                            return _c(
                              "el-tag",
                              {
                                key: ind,
                                staticStyle: { "margin-right": "5px" },
                                attrs: { closable: "", size: "small" },
                                on: {
                                  close: function ($event) {
                                    return _vm.handleClose(
                                      _vm.grabbeditdata.inquiryMaintainList[0]
                                        .destinationObj,
                                      ind
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(tag.cityName))]
                            )
                          }
                        ),
                        1
                      ),
                      _c("city-autocomplete", {
                        attrs: {
                          width: "    margin-left: 5px;width:94px",
                          obj: _vm.grabbeditdata,
                          sizeType: "small",
                          action: false,
                        },
                        on: { handleSelect: _vm.handleSelect },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentdestination()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("预估出行日期:")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelStart != "" &&
                            _vm.grabbeditdata.traveldatashow == false,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].estimatedTravelStart != '' &&grabbeditdata.traveldatashow == false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dateFormatYMD(
                              _vm.grabbeditdata.inquiryMaintainList[0]
                                .estimatedTravelStart,
                              "-"
                            )
                          ) +
                          " "
                      ),
                      _vm.grabbeditdata.inquiryMaintainList[0]
                        .estimatedTravelEnd
                        ? _c("span", [_vm._v("-")])
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelEnd == ""
                              ? ""
                              : _vm.dateFormatYMD(
                                  _vm.grabbeditdata.inquiryMaintainList[0]
                                    .estimatedTravelEnd,
                                  "-"
                                )
                          ) +
                          " "
                      ),
                      _vm.grabbeditdata.inquiryMaintainList[0]
                        .estimatedTravelEnd
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.grabbeditdata.inquiryMaintainList[0]
                                    .estimatedTravelEnd /
                                    (3600 * 24 * 1000) -
                                    _vm.grabbeditdata.inquiryMaintainList[0]
                                      .estimatedTravelStart /
                                      (3600 * 24 * 1000) +
                                    1
                                ) +
                                "天"
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.traveldatashow == true,
                          expression: "grabbeditdata.traveldatashow == true",
                        },
                      ],
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          size: "mini",
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        model: {
                          value: _vm.grabbeditdata.traveldatato,
                          callback: function ($$v) {
                            _vm.$set(_vm.grabbeditdata, "traveldatato", $$v)
                          },
                          expression: "grabbeditdata.traveldatato",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmenttraveldata()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("预估出行人数:")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultChildren != null &&
                            _vm.grabbeditdata.estimatednumshow == false,
                          expression:
                            " grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren != null &&grabbeditdata.estimatednumshow == false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultNum
                          ) +
                          "成人" +
                          _vm._s(
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultChildren
                          ) +
                          "儿童 "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultChildren == null ||
                            _vm.grabbeditdata.estimatednumshow == true,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren == null ||grabbeditdata.estimatednumshow == true",
                        },
                      ],
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, size: "mini" },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultNum,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "estimatedTravelAdultNum",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultNum",
                        },
                      }),
                      _vm._v("成人 "),
                      _c("el-input-number", {
                        attrs: { min: 0, size: "mini" },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .estimatedTravelAdultChildren,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "estimatedTravelAdultChildren",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].estimatedTravelAdultChildren",
                        },
                      }),
                      _vm._v("儿童 "),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentestimatednum()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("预算:")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0].price !=
                              null && _vm.grabbeditdata.budgetshow == false,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].price != null &&grabbeditdata.budgetshow == false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.grabbeditdata.inquiryMaintainList[0].price
                          ) +
                          "/人 "
                      ),
                      _vm.grabbeditdata.inquiryMaintainList[0].type == 0
                        ? _c("span", [_vm._v("不含机票")])
                        : _vm._e(),
                      _vm.grabbeditdata.inquiryMaintainList[0].type == 1
                        ? _c("span", [_vm._v("含经济舱")])
                        : _vm._e(),
                      _vm.grabbeditdata.inquiryMaintainList[0].type == 2
                        ? _c("span", [_vm._v("含公务/头等舱")])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0].price ==
                              null || _vm.grabbeditdata.budgetshow == true,
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].price == null ||grabbeditdata.budgetshow == true",
                        },
                      ],
                    },
                    [
                      _c(
                        "span",
                        [
                          _c("el-input", {
                            staticStyle: { width: "80px" },
                            attrs: { size: "mini" },
                            model: {
                              value:
                                _vm.grabbeditdata.inquiryMaintainList[0].price,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.grabbeditdata.inquiryMaintainList[0],
                                  "price",
                                  $$v
                                )
                              },
                              expression:
                                "grabbeditdata.inquiryMaintainList[0].price",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" /人 "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "5px", width: "50px" },
                          attrs: { label: "0" },
                          model: {
                            value:
                              _vm.grabbeditdata.inquiryMaintainList[0].type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.grabbeditdata.inquiryMaintainList[0],
                                "type",
                                $$v
                              )
                            },
                            expression:
                              "grabbeditdata.inquiryMaintainList[0].type",
                          },
                        },
                        [_vm._v("不含机票")]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "5px", width: "50px" },
                          attrs: { label: "1" },
                          model: {
                            value:
                              _vm.grabbeditdata.inquiryMaintainList[0].type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.grabbeditdata.inquiryMaintainList[0],
                                "type",
                                $$v
                              )
                            },
                            expression:
                              "grabbeditdata.inquiryMaintainList[0].type",
                          },
                        },
                        [_vm._v("含经济舱")]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-left": "5px", width: "50px" },
                          attrs: { label: "2" },
                          model: {
                            value:
                              _vm.grabbeditdata.inquiryMaintainList[0].type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.grabbeditdata.inquiryMaintainList[0],
                                "type",
                                $$v
                              )
                            },
                            expression:
                              "grabbeditdata.inquiryMaintainList[0].type",
                          },
                        },
                        [_vm._v("含公务/头等舱")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentbudget()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _vm.grabbeditdata.type == 1
                  ? _c("p", { staticClass: "checkButtonP" }, [
                      _c("span", [_vm._v("主题:")]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.themeshow == false,
                              expression: "grabbeditdata.themeshow == false",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _vm._l(
                            _vm.grabbeditdata.themesplit,
                            function (item, index) {
                              return _c("span", { key: index }, [
                                _vm._v(_vm._s(item)),
                                index != _vm.grabbeditdata.themesplit.length - 1
                                  ? _c("span", [_vm._v("、")])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _vm.grabbeditdata.inquiryMaintainList[0].otherTheme
                            ? _c("span", [
                                _vm._v(
                                  ";" +
                                    _vm._s(
                                      _vm.grabbeditdata.inquiryMaintainList[0]
                                        .otherTheme
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.themeshow == true,
                              expression: "grabbeditdata.themeshow == true",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticStyle: { width: "395px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.grabbeditdata.themesplit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.grabbeditdata, "themesplit", $$v)
                                },
                                expression: "grabbeditdata.themesplit",
                              },
                            },
                            _vm._l(_vm.themeList, function (theme) {
                              return _c(
                                "el-checkbox-button",
                                {
                                  key: theme,
                                  staticStyle: { margin: "2px" },
                                  attrs: { label: theme },
                                },
                                [_vm._v(_vm._s(theme))]
                              )
                            }),
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "230px",
                              "margin-top": "5px",
                            },
                            attrs: { placeholder: "其他主题", size: "mini" },
                            model: {
                              value:
                                _vm.grabbeditdata.inquiryMaintainList[0]
                                  .otherTheme,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.grabbeditdata.inquiryMaintainList[0],
                                  "otherTheme",
                                  $$v
                                )
                              },
                              expression:
                                "grabbeditdata.inquiryMaintainList[0].otherTheme",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "line-height": "25px",
                            float: "right",
                            "margin-right": "15px",
                            color: "#e65019",
                            "font-weight": "bold",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.adjustmenttheme()
                            },
                          },
                        },
                        [_vm._v("调整")]
                      ),
                    ])
                  : _vm._e(),
                _vm.grabbeditdata.type == 1
                  ? _c("p", { staticClass: "checkButtonP" }, [
                      _c("span", [_vm._v("行程期待:")]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.tripshow == false,
                              expression: "grabbeditdata.tripshow == false",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _vm._l(
                            _vm.grabbeditdata.planExpectsplit,
                            function (item, index) {
                              return _c("span", { key: index }, [
                                _vm._v(_vm._s(item)),
                                index !=
                                _vm.grabbeditdata.planExpectsplit.length - 1
                                  ? _c("span", [_vm._v("、")])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _vm.grabbeditdata.otherPlanExpect
                            ? _c("span", [_vm._v(";")])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.grabbeditdata.otherPlanExpect)),
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.tripshow == true,
                              expression: "grabbeditdata.tripshow == true",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticStyle: { width: "395px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.grabbeditdata.planExpectsplit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.grabbeditdata,
                                    "planExpectsplit",
                                    $$v
                                  )
                                },
                                expression: "grabbeditdata.planExpectsplit",
                              },
                            },
                            _vm._l(_vm.expectList, function (trip) {
                              return _c(
                                "el-checkbox-button",
                                { key: trip, attrs: { label: trip } },
                                [_vm._v(_vm._s(trip))]
                              )
                            }),
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "230px",
                              "margin-top": "5px",
                            },
                            attrs: { placeholder: "其他期待", size: "mini" },
                            model: {
                              value:
                                _vm.grabbeditdata.inquiryMaintainList[0]
                                  .otherPlanExpect,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.grabbeditdata.inquiryMaintainList[0],
                                  "otherPlanExpect",
                                  $$v
                                )
                              },
                              expression:
                                "grabbeditdata.inquiryMaintainList[0].otherPlanExpect",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "line-height": "25px",
                            float: "right",
                            "margin-right": "15px",
                            color: "#e65019",
                            "font-weight": "bold",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.adjustmenttrip()
                            },
                          },
                        },
                        [_vm._v("调整")]
                      ),
                    ])
                  : _vm._e(),
                _vm.grabbeditdata.type == 2
                  ? _c("p", { staticClass: "checkButtonP" }, [
                      _c("span", [_vm._v("所需服务:")]),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.themeshow == false,
                              expression: "grabbeditdata.themeshow == false",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _vm._l(
                            _vm.grabbeditdata.themesplit,
                            function (item, index) {
                              return _c("span", { key: index }, [
                                _vm._v(_vm._s(item)),
                                index != _vm.grabbeditdata.themesplit.length - 1
                                  ? _c("span", [_vm._v("、")])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _vm.grabbeditdata.inquiryMaintainList[0].otherTheme
                            ? _c("span", [
                                _vm._v(
                                  ";" +
                                    _vm._s(
                                      _vm.grabbeditdata.inquiryMaintainList[0]
                                        .otherTheme
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.grabbeditdata.themeshow == true,
                              expression: "grabbeditdata.themeshow == true",
                            },
                          ],
                          staticClass: "checkButtonSpan",
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticStyle: { width: "395px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.grabbeditdata.themesplit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.grabbeditdata, "themesplit", $$v)
                                },
                                expression: "grabbeditdata.themesplit",
                              },
                            },
                            _vm._l(_vm.serviceList, function (theme) {
                              return _c(
                                "el-checkbox-button",
                                { key: theme, attrs: { label: theme } },
                                [_vm._v(_vm._s(theme))]
                              )
                            }),
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "230px",
                              "margin-top": "5px",
                            },
                            attrs: { placeholder: "其他主题", size: "mini" },
                            model: {
                              value:
                                _vm.grabbeditdata.inquiryMaintainList[0]
                                  .otherTheme,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.grabbeditdata.inquiryMaintainList[0],
                                  "otherTheme",
                                  $$v
                                )
                              },
                              expression:
                                "grabbeditdata.inquiryMaintainList[0].otherTheme",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "line-height": "25px",
                            float: "right",
                            "margin-right": "15px",
                            color: "#e65019",
                            "font-weight": "bold",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.adjustmenttheme()
                            },
                          },
                        },
                        [_vm._v("调整")]
                      ),
                    ])
                  : _vm._e(),
                _c("p", { staticClass: "checkButtonP" }, [
                  _c("span", [_vm._v("包含项目:")]),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.expectshow == false,
                          expression: "grabbeditdata.expectshow == false",
                        },
                      ],
                      staticClass: "checkButtonSpan",
                    },
                    [
                      _vm._l(
                        _vm.grabbeditdata.needServicesplit,
                        function (item, index) {
                          return _c("span", { key: index }, [
                            _vm._v(_vm._s(item)),
                            index !=
                            _vm.grabbeditdata.needServicesplit.length - 1
                              ? _c("span", [_vm._v("、")])
                              : _vm._e(),
                          ])
                        }
                      ),
                      _vm.grabbeditdata.otherNeedService
                        ? _c("span", [_vm._v(";")])
                        : _vm._e(),
                      _vm._v(_vm._s(_vm.grabbeditdata.otherNeedService) + " "),
                    ],
                    2
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.expectshow == true,
                          expression: "grabbeditdata.expectshow == true",
                        },
                      ],
                      staticClass: "checkButtonSpan",
                    },
                    [
                      _vm.grabbeditdata.type == 1
                        ? _c(
                            "el-checkbox-group",
                            {
                              staticStyle: { width: "395px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.grabbeditdata.needServicesplit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.grabbeditdata,
                                    "needServicesplit",
                                    $$v
                                  )
                                },
                                expression: "grabbeditdata.needServicesplit",
                              },
                            },
                            _vm._l(_vm.projectListOne, function (trip) {
                              return _c(
                                "el-checkbox-button",
                                { key: trip, attrs: { label: trip } },
                                [_vm._v(_vm._s(trip))]
                              )
                            }),
                            1
                          )
                        : _c(
                            "el-checkbox-group",
                            {
                              staticStyle: { width: "395px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.grabbeditdata.needServicesplit,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.grabbeditdata,
                                    "needServicesplit",
                                    $$v
                                  )
                                },
                                expression: "grabbeditdata.needServicesplit",
                              },
                            },
                            _vm._l(_vm.projectListTwo, function (trip) {
                              return _c(
                                "el-checkbox-button",
                                { key: trip, attrs: { label: trip } },
                                [_vm._v(_vm._s(trip))]
                              )
                            }),
                            1
                          ),
                      _c("el-input", {
                        staticStyle: { width: "230px", "margin-top": "5px" },
                        attrs: { placeholder: "其他期待", size: "mini" },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .otherNeedService,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "otherNeedService",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].otherNeedService",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentexpect()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
                _c("p", { staticStyle: { margin: "0 10px" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        width: "80px",
                        margin: "10px",
                        "font-weight": "bold",
                        display: "inline-block",
                      },
                    },
                    [_vm._v("客户留言:")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.expectliushow == false,
                          expression: "grabbeditdata.expectliushow == false",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.grabbeditdata.inquiryMaintainList[0]
                            .customerMessage
                        )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.grabbeditdata.expectliushow == true,
                          expression: "grabbeditdata.expectliushow == true",
                        },
                      ],
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "230px" },
                        attrs: {
                          placeholder: "请您输入你的留言",
                          size: "mini",
                        },
                        model: {
                          value:
                            _vm.grabbeditdata.inquiryMaintainList[0]
                              .customerMessage,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.grabbeditdata.inquiryMaintainList[0],
                              "customerMessage",
                              $$v
                            )
                          },
                          expression:
                            "grabbeditdata.inquiryMaintainList[0].customerMessage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "line-height": "25px",
                        float: "right",
                        "margin-right": "15px",
                        color: "#e65019",
                        "font-weight": "bold",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.adjustmentliuexpect()
                        },
                      },
                    },
                    [_vm._v("调整")]
                  ),
                ]),
              ]),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "ordershowcard-buttom",
              on: {
                click: function ($event) {
                  return _vm.savetripdata()
                },
              },
            },
            [_vm._v("保存并在我抢到的方案中制作行程")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }